// removed by extract-text-webpack-plugin
module.exports = {"blogPostItem":"_3M3nGbihTvHkx5gtn6iSiV","listImg":"_1t9iXOnAZdEW7UoZ7Gxzuh","content":"_1V2wa4eQpzPvedc6P1Mcdu","placeholder":"_2svxSn4fNIgK_nY2PGM5sY","postTitle":"YReWsQhBeuxXmjcrEr_q","postExtract":"_39Vog_xhY-ftF0OVvzCXUE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/blog-post-item/BlogPostItem.css
// module id = 405
// module chunks = 0